import T from 'i18n-react';
import { useEffect } from 'react';
import { useReducerData, useStoreActions } from 'store/hooks';
import * as thisActions from 'views/DocumentManagement/redux/actions';

const useThisActions = () => {
  return useStoreActions({
    ...thisActions,
  });
};

const useDocumentManagementFiltersDropdown = () => {
  const { getDocumentManagementFilterTypes, getDocumentManagementFilterSources } = useThisActions();
  const filterTypes = useReducerData('documentManagement', 'filterTypes.data.list', []);
  const filterSources = useReducerData('documentManagement', 'filterSources.data', []);
  const typeOptions = filterTypes.map((obj) => {
    const tText = T.translate(`documentManagement.type.${obj.name}`);
    const displayText = tText.includes('documentManagement.type.') ? obj.name : tText;
    return {
      value: obj.name,
      label: displayText,
      obj,
    };
  });

  const sourceOptions = Array.isArray(filterSources)
    ? filterSources.map((v) => ({
        value: v,
        label: T.translate(`documentManagement.source.${v}`),
      }))
    : [];

  useEffect(() => {
    getDocumentManagementFilterTypes({
      pageNo: 1,
      pageSize: 1000,
    });
    getDocumentManagementFilterSources();
  }, []);

  return {
    typeOptions,
    sourceOptions,
  };
};

export default useDocumentManagementFiltersDropdown;
